export default "__VITE_ASSET__BfPZqBQ7__"